import 'rxjs/add/observable/forkJoin';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { HelperService } from '../../../../../services/helper/helper.service';

@Injectable()
export class ExchangeStudentService {

  constructor(
    private http: HttpClient,
    private helper: HelperService
  ) { }

  getByClass(type, classId, courseId, params, callback) {
    this.http.get(
      '/exchange/' + type + '/course-participant/' + courseId + '/' + classId,
      { params }
    ).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getByClassForDiplomaPaperOrGraduation(type, classId, id, params, callback) {
    type = type === 'diplomaPaper' ? 'diploma-paper' : 'other';
    this.http.get(
      '/exchange/' + type + '/student/participant/' + id + '/' + classId,
      { params }
    ).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getFromGuestList(courseId, params, callback) {
    this.http.get('/guest-student/user/' + courseId, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getByCourse(type: 'alumni' | 'student', courseId, params, callback) {
    this.http.get('/exchange/' + type + '/' + courseId, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getByRLP(type: 'alumni' | 'student', rlpId, moduleId, params, callback) {
    params = { ...params, id: moduleId, case: 'by-module' };
    Observable.forkJoin(
      this.http.get('/exchange/' + type, { params }),
      this.http.get('/exchange/rlp/' + type + '/' + rlpId)
    ).subscribe(
      (res: any) => {
        const response = res[0];
        response.data = response.data.map(data => ({
          ...data,
          selected: res[1].map(user => user.id).includes(data.id)
        }));
        callback(null, response);
      },
      err => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  getByRLPForGrades(type: 'alumni' | 'student', rlpId, params, callback) {
    this.http.get('/exchange/rlp/' + type + '/' + rlpId, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getByRLPForGradesParallel(type: 'alumni' | 'student', rlpId, params, callback) {
    this.http.get(`/parallel/rlp/show-${type}/${rlpId}`, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getByDiplomaPaperOrGraduation(studentType: 'alumni' | 'student', participantFor: 'diploma-paper' | 'other', id, params, callback) {
    this.http.get('/exchange/' + participantFor + '/' + studentType + '/' + id, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getGuestByCourse(courseId, params, callback) {
    this.http.get('/guest-student/user/selected/' + courseId, { params }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  addToCourse(type, payload, callback) {
    this.http.post('/exchange/' + type, payload).subscribe(
      res => callback(null, res),
      callback
    );
  }

  addToRLP(type: 'alumni' | 'student', payload: { user_id: number[], real_life_project_id: number }, callback) {
    this.http.post('/exchange/rlp/' + type, payload).subscribe(
      res => callback(null, res),
      err => this.helper.handleError(err, 'warning') && callback(err)
    );
  }

  addToDiplomaPaperOrGraduation(type, payload, callback) {
    type = type === 'diplomaPaper' ? 'diploma-paper' : 'other';
    this.http.post('/exchange/' + type + '/student', payload).subscribe(
      res => callback(null, res),
      callback
    );
  }

  addGuestToCourse(payload, callback) {
    this.http.put('/guest-student/user/' + payload.course_id, payload).subscribe(
      res => callback(null, res),
      callback
    );
  }

  delete(student, callback) {
    if (student.exchange_alumni && student.exchange_alumni.length) {
      this.http.delete('/exchange/alumni/' + student.exchange_alumni[0].id).subscribe(
        res => callback(null, res),
        callback
      );
    } else if (student.exchange_student && student.exchange_student.length) {
      this.http.delete('/exchange/student/' + student.exchange_student[0].id).subscribe(
        res => callback(null, res),
        callback
      );
    } else if (student.guest_student && student.guest_student.length) {
      this.http.delete('/guest-student/user/' + student.guest_student[0].id).subscribe(
        res => callback(null, res),
        callback
      );
    } else if (student.parallel_student && student.parallel_student.length) {
      this.http.delete('/parallel/student/' + student.parallel_student[0].id).subscribe(
        res => callback(null, res),
        callback
      );
    }
  }

  deleteRLPParallel(id, student, callback) {
    this.http.delete('/real-life-project-parallel-class-participant-remove/' + student.id + '/' + id).subscribe(
      res => callback(null, res),
      callback
    );
  }

  deleteFromDiplomaPaperOrGraduation(type, student, callback) {
    type = type === 'diplomaPaper' ? 'diploma-paper' : 'other';
    const id = type === 'diploma-paper' ? student.es_diploma_paper[0].id : student.es_other[0].id;
    this.http.delete('/exchange/' + type + '/student/' + id).subscribe(
      res => callback(null, res),
      callback
    );
  }

  getAllGuestStudents(params, callback) {
    this.http.get('/guest-student/user/', { params }).subscribe(
      res => callback(null, res),
      err => callback(err)
    );
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/services/exchange-student/exchange-student.service.ts